import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-[#FAFAFA] min-h-screen">
      <section className="bg-[#1A362D] py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#8FA38C]">Support</span>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold text-white tracking-tight">
            Frequently asked questions
          </h1>
          <p className="mt-5 text-white/80 text-lg font-light">Everything you need to know about working with Master Touch.</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-[#E2E8E4]/60 rounded-xl px-6">
              <AccordionTrigger className="text-left font-heading text-xl font-medium text-[#1A362D] hover:no-underline py-5">
                <span className="flex items-center gap-3">
                  <HelpCircle className="h-5 w-5 text-[#C47B57] shrink-0" /> {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-[#4A5D4E] font-light text-base pb-5 pl-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center p-10 rounded-2xl bg-white border border-[#E2E8E4]/60">
          <h3 className="font-heading text-2xl font-semibold text-[#1A362D]">Still have questions?</h3>
          <p className="mt-2 text-[#4A5D4E] font-light">Our team is happy to help you choose the right service.</p>
          <Button onClick={() => navigate("/contact")} className="mt-5 bg-[#C47B57] hover:bg-[#D58C68] text-white rounded-full px-8">
            Contact Us
          </Button>
        </div>
      </section>
    </div>
  );
}
